import { IList } from 'annotation-tools/utils';
import React, { memo, useMemo } from 'react';
import { texts } from '../../../constants/texts';
import { IBboxType, IdType } from '../../../imports/annotation-canvas';
import { AnnotationItemListView } from '../../../imports/ui-parts';

export const AnnotationItemList = memo(
  ({
    bboxes,
    onClick,
    onHover,
    selectedId,
    highlightId,
    hidden,
    onHiddenChange,
    disabled
  }: Readonly<{
    bboxes: IList<IBboxType>;
    onClick: (id: IdType | undefined) => void;
    onHover: (id: IdType | undefined) => void;
    selectedId: IdType | undefined;
    highlightId: IdType | undefined;
    hidden: boolean;
    onHiddenChange: (v: boolean) => void;
    disabled: boolean;
  }>) => {
    const list = useMemo(
      () => bboxes.map(bbox => ({ id: bbox.id, displayName: bbox.label.name })),
      [bboxes]
    );

    return (
      <AnnotationItemListView
        list={list}
        onClick={onClick}
        onHover={onHover}
        selectedId={selectedId}
        highlightId={highlightId}
        hidden={hidden}
        onHiddenChange={onHiddenChange}
        disabled={disabled}
        title={texts.annotationList}
      />
    );
  }
);

AnnotationItemList.displayName = 'AnnotationItemList';
